<template>
  <CardContainer :tile="true" elevation="0" :hideTitle="true" :hideSubtitle="true">
    <template v-slot:content>
      <v-row no-gutters>
        <v-col cols="12" class="title">
          {{ product.name }}
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="6">
          <v-img :src="image" position="top"/>
        </v-col>
        <v-col cols="6">
          <v-row no-gutters>
            <v-col cols="12" class="text-center text-h6 prices" v-if="product.current_promotion">
              <div>{{ $store.state.text.common.price }}</div>
              <div class="text-decoration-line-through">
                {{ product.current_product_price.price_gross }}
                {{ $store.state.text.common.currency }}
              </div>
            </v-col>

            <v-col cols="12" class="text-center text-h5 color-primary">
              {{ text.common.priceForYou }}
              <div v-if="product.current_promotion" class="text-xl-h4">
                <strong>
                  {{ product.current_promotion.price_gross }}
                  {{ $store.state.text.common.currency }}
                </strong>
              </div>
              <div v-else-if="product.current_product_price" class="text-xl-h4">
                <strong>
                  {{ product.current_product_price.price_gross }}
                  {{ $store.state.text.common.currency }}
                </strong>
              </div>
            </v-col>

            <v-col cols="12" class="text-center">
              <v-btn small outlined color="primary" tile @click="addProductToBasket">
                {{ text.common.addToCart }}
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12" v-html="product.description"/>
      </v-row>
    </template>
  </CardContainer>
</template>

<script>
import CardContainer from '@/components/Partials/CardContainer.vue';
import Basket from '@/core/Basket';
import { translations } from '@/lang/translations';

export default {
  name: 'ProductMobile',
  components: { CardContainer },
  props: ['productDetails'],
  data() {
    return {
      basket: new Basket(),
      url: process.env.VUE_APP_URL,
    };
  },
  computed: {
    product() {
      return this.productDetails;
    },
    text() {
      return translations[this.$store.state.language];
    },
    image() {
      if (this.product.image.length === 0) {
        return '/img/norbit_nocover.png';
      }
      const imageBox = this.product.image
        .filter((value) => parseInt(value.pivot.image_type_id, 10) === 3);
      if (imageBox.length === 0) {
        return '/img/norbit_nocover.png';
      }
      return this.url + imageBox[0].pivot.image_link;
    },
    language() {
      const lang = this.product.attributes
        .filter((value) => parseInt(value.pivot.attribute_id, 10) === 1);
      if (lang.length > 0) {
        return lang[0].name;
      }
      return 'EN';
    },
  },
  methods: {
    addProductToBasket() {
      const price = this.product.current_promotion ? this.product.current_promotion.price_gross
        : this.product.current_product_price.price_gross;
      this.basket.addItemToBasket(this.product.id, this.product.name, price);
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Lato:400,700");

.title {
  font-family: 'Lato', sans-serif;
  color: #555555;
}

.description. {
  font-family: 'Lato', sans-serif;
  color: #bcbcbc;
}

.details {
  position: absolute;
  bottom: 3em;
  margin-left: 1.5em;
  line-height: 0.1em;
}

.detail_name {
  color: #000000;
}

.detail_link {
  color: #bcbcbc;
  text-decoration: none;
}

.detailbg {
  height: 30em;
}

.color-primary {
  color: #0086ca;
}

.text-h6 {
  line-height: 1em !important;
}
</style>
